import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Table, Column, Button } from '@smartplatform/ui';
import store from '../../store';

@observer
export default class List extends React.Component {

	@observable records = null;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.records = await store.model.DivisionGroup.find({
			include: [
				{ relation: 'divisions', scope: { fields: { id: true, number: true }}}
			],
			order: 'id asc'
		});
	};
	
	create = () => this.props.history.push('/admin/divisiongroups/create');
	
	numbers = group => group.divisions().map(division => division.number).join(', ');
	
	render() {
		if (!this.records) return '...';
		
		return <>
			<p>Региональные группы</p>
			<p><Button className="btn-primary" onClick={this.create}>Создать</Button></p>
			<Table records={this.records} rootPath="/admin">
				<Column width={50} property="id" label="id" />
				<Column property="name" label="Наименование" />
				<Column computed={this.numbers} label="Номера избирательных округов" />
			</Table>
		</>;
	}
	
}
